import "./styles/globals.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import App from "./App";
import { AuthProvider } from "./store/authContext";
import { OrgProvider } from "./store/orgContext";
import "react-toastify/dist/ReactToastify.css";
import { SearchProvider } from "./store/searchContext";
import { DFSIProvider } from "./store/dfsiContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <OrgProvider>
          <SearchProvider>
            <DFSIProvider>
              <App />
            </DFSIProvider>
          </SearchProvider>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
    <ToastContainer />
  </React.StrictMode>
);
